import { datetimeSchema } from './datetime'
import { monitorTypeSchema } from './monitor'
import { z } from 'zod'

export const monitorLogSchema = z
  .object({
    id: z.string(),
    created_at: datetimeSchema,
    created_alerts_count: z.number().default(0),
    status: z
      .enum(['in_progress', 'successful', 'failed', 'max_alerts_reached'])
      .default('successful'),
    filters_id: z.string(),
    natural_language_description: z.string(),
    type: monitorTypeSchema,
  })
  .transform((data) => {
    const {
      created_at,
      created_alerts_count,
      natural_language_description,
      filters_id,
      ...logData
    } = data

    return {
      createdAt: created_at,
      createdAlertsCount: created_alerts_count,
      naturalLanguageDescription: natural_language_description,
      filtersId: filters_id,
      ...logData,
    }
  })

export type MonitorLog = z.infer<typeof monitorLogSchema>
